export const nursingAllowanceConfirmationWidgetFragment = `
    id
    folderId
    confirmedUntil
    careStartDate
    folder {
        id
        serviceId
        person {
            id
            name
            surname
        }
    }
`;
